import React, { Component } from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';

require('codemirror/lib/codemirror.css');
require('codemirror/theme/neat.css');

require('codemirror/mode/htmlmixed/htmlmixed.js');
require('codemirror/mode/javascript/javascript.js');
require('codemirror/mode/ruby/ruby.js');
require('codemirror/mode/sql/sql.js');
require('codemirror/mode/xml/xml.js');

require('codemirror/addon/search/search.js');
require('codemirror/addon/search/searchcursor.js');
require('codemirror/addon/search/match-highlighter.js');
require('codemirror/addon/search/matchesonscrollbar.css');
require('codemirror/addon/search/matchesonscrollbar.js');
require('codemirror/addon/search/jump-to-line.js');
require('codemirror/addon/dialog/dialog.js');
require('codemirror/addon/dialog/dialog.css');

type Props = {
  input: any,
  label: string,
  mode: string
};

class CodeMirrorInput extends Component<Props> {
  handleChange = (editor, data, value) => {
    this.props.input.onChange(value);
  };

  render() {
    return (
      <div>
        <span style={{ color: "rgba(0, 0, 0, 0.298039)", fontSize: 16 }}>
          {this.props.label}
        </span>
        <br />
        <div style={{ border: "1px solid #cccccc", maxWidth: 1100 }}>
          <CodeMirror
            value={this.props.input.value}
            options={{
              extraKeys: { "Ctrl-Space": "autocomplete" },
              lineNumbers: true,
              lineWrapping: true,
              mode: { name: this.props.mode, globalVars: true },
              theme: "neat"
            }}
            onBeforeChange={(editor, data, value) => {
              this.handleChange(editor, data, value);
            }}
            onChange={(event, key, value) => { }}
          />
        </div>
        Press <u>Ctrl-F / Cmd-F</u> to activate search.
        <br />
        Press <u>Ctrl-G / Cmd-G</u> to Find next.
        <br />
        <br />
      </div>
    );
  }
};

export default CodeMirrorInput;



// WEBPACK FOOTER //
// ./src/views/Common/Utils/CodeMirrorInput.tsx